export function Wrapper(props:{children:any}){
    return <div style={{padding:20,backgroundColor:"rgb(255,255,255)",width:"100%",height:"100%"}}>
        {props.children}
    </div>
}